<template>
    <!-- TODO: Pass input cssNs somehow? (probably not possible without passing the whole @input component) -->
    <div class="crud::form-inputs-Password" data-style="tailwind" dusk="password">
        <div class="flex flex-wrap pb-10 mt-10 mb-5">
            <label class="w-full pr-4 lg:w-1/3">
                <h5>{{ label }}<span v-if="required" class="text-red-400"> *</span></h5>
            </label>

            <div class="w-full pl-3 pr-1 lg:w-2/3">
                <div class="flex">
                    <div class="w-full pr-2">
                        <input
                            v-model="password"
                            :class="defaultInputClass"
                            :name="name"
                            :required="required"
                            v-bind:type="[showPassword ? 'text' : 'password']"
                            :autocomplete="autocomplete"
                            :placeholder="placeholder"
                        />

                        <password
                            v-model="password"
                            :secure-length="8"
                            :strength-meter-class="defaultMeterClass"
                            :strength-meter-only="true"
                        />
                    </div>

                    <div class="flex">
                        <button
                            class="text-white px-2 py-2 w-[42px] h-[42px] bg-indigo-500 hover:bg-indigo-800 transition rounded-md"
                            @click.prevent="showPassword = !showPassword"
                        >
                            <i
                                :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']"
                                :title="[showPassword ? 'Verberg wachtwoord' : 'Laat wachtwoord zien']"
                                aria-hidden="true"
                                class="fas"
                            >
                            </i>
                        </button>

                        <button
                            class="relative text-white px-2 py-2 w-[42px] h-[42px] bg-indigo-500 hover:bg-indigo-800 transition rounded-md ml-2"
                            @click.prevent="generatePassword()"
                        >
                            <i :title="'Genereer een willekeurig wachtwoord.'" class="fas fa-random"> </i>
                        </button>
                    </div>
                </div>

                <small class="block mt-2 text-gray-500">{{ instruction }}</small>

                <div v-for="(error, index) in errors" :key="index">
                    <div class="p-4 mt-2 border border-red-200 rounded-md bg-red-50">
                        <div class="flex">
                            <div class="flex-shrink-0">
                                <svg
                                    aria-hidden="true"
                                    class="w-5 h-5 text-red-400"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        clip-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                        fill-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <div class="ml-3">
                                <div class="text-sm text-red-700">
                                    <p>
                                        {{ error }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Password from 'vue-password-strength-meter';
import SRP from 'secure-random-password';

export default {
    components: {
        Password,
    },

    props: {
        instruction: String,
        label: String,
        name: String,
        required: Boolean,
        errors: Array,
        autocomplete: String,
        placeholder: String,

        defaultInputClass: {
            type: String,
            default: 'focus:border-indigo-500 focus:ring-indigo-500 bg-white text-base block border border-gray-300 px-4 py-2 rounded w-full',
        },

        defaultMeterClass: {
            type: String,
            default: 'relative bg-gray-300 h-2 mt-2 rounded-md',
        },

        size: {
            type: String,
            default: '16',
        },
    },

    data: () => ({
        password: null,
        showPassword: false,
    }),

    methods: {
        async generatePassword() {
            let passwordConfirmField = $('input[name*="password_confirmation"]');
            let password = SRP.randomPassword({
                length: parseInt(this.size),
                characters: [SRP.lower, SRP.upper, SRP.digits, SRP.symbols],
            });

            // Set random password.
            this.password = password;
            this.showPassword = true;

            // Set password confirmation
            passwordConfirmField.val(password);

            // Copy password to clipboard
            await navigator.clipboard.writeText(password);

            // Notify user about password in clipboard
            this.$toasted.show('<i class="far fa-check-circle"></i> Het wachtwoord is naar je klembord gekopieerd.', {
                type: 'success',
                position: 'bottom-right',
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.crud\:\:form-inputs-Password {
    // Overwrite vue-password-strength-meter styling
    .Password {
        max-width: 100% !important;
        margin: 0 !important;
    }
}
</style>
